// GCDKの必須タグのCSSをコピーして作成した
// TODO: GCDKで必須タグがリリースされたら、そちらを使い、このコンポーネントを削除する
export const RequiredTag = () => {
  return (
    <span
      style={{
        background: "#fff6f8",
        color: "#b1110c",
        padding: "4px 6px",
        borderRadius: "30px",
        marginLeft: "8px",
        font: "14px/24px Hiragino Sans, Arial, Meiryo, system-ui, sans-serif",
      }}
    >
      必須
    </span>
  );
};
